import {
    Backdrop,
    Box,
    Grid,
    Grow,
    Modal,
} from '@material-ui/core';
import React, { useState } from "react";
import 'react-datepicker/dist/react-datepicker.css';
import { FormattedMessage, useIntl } from 'react-intl';
import Switch from "react-switch";
import swal from 'sweetalert2';
import * as Utils from '../../commons/utils/Utils';
import $ from 'jquery';
import ConfigBusiness from '../../commons/config/ConfigBusiness.js';

const DisponibilidadGridExport = ( props ) => {
    const intl = useIntl();
    const ITEM_XS = 3;
    const [loading, setLoading] = useState(false);
    const [dataToExport, setDataToExport] = useState({
        dominio: true,
        motivo: true,
        fechaRetorno: true,
        modelo: true,
        tipoModelo: true,
        base: true,
        subregion: true,
        region: true,
        transportadora: ConfigBusiness.get('moviles.transportadora.grilla') === 'true',
        cecos: true,
        fechaHoraInicioOciosidad: true,
        horasOciosidad: true,
        esReserva: false
    });

    const handleDataExport = (column) => {
        setDataToExport((prev) => ({
            ...prev,
            [column]: !prev[column],
        }));
    };
    
    const handleExportExcel = (event) => {
        
        let queryFilters = props.queryFilters;
        event.preventDefault()
        setLoading(true)

        swal.fire({
            title: intl.formatMessage({ id: "azureCallback.information.aguarde_instantes", defaultMessage: "Aguarde unos instantes" }),
            html: intl.formatMessage({ id: "disponibilidadGrid.render.export_modal.columns_export.information_esta_accion_puede_demorar_unos_minutos", defaultMessage: "Esta acción puede demorar unos minutos." }),
            allowOutsideClick: false,
            onBeforeOpen: () => {
                swal.showLoading()
            },
        });

        let auxDataToExport = JSON.stringify({
            colsAExportar: dataToExport,
            queryFilters: queryFilters
        })

        Utils.dataBlob(`/disponibilidad/exportar-excel`, 'POST', auxDataToExport)
            .then(res => {
                swal.close()
                let fileBlob = new File([res.data], res.filename)
                let fileUrl = URL.createObjectURL(fileBlob);
                $("<a />", {
                    href: fileUrl,
                    download: res.filename.replace(/"/g, "")
                }).appendTo("body").get(0).click();
            }).catch((err) => {
                console.log(err)
            }).finally(() => {
                props.handleClose();
                setLoading(false)
            })
    }

    return (
        <Modal
            open={props.open}
            closeAfterTransition
            BackdropComponent={Backdrop}
            BackdropProps={{
                timeout: 1000,
            }}
            style={{
                display: 'flex',
                alignItems: 'flex-start',
                justifyContent: 'center',
                marginTop: '1vh',
            }}
        >
            <Grow in={props.open}>
                <div
                    className="modal-xl modal-dialog"
                    tabIndex="-1"
                    id="export_modal"
                    role="dialog"
                    aria-labelledby="myModalLabel3"
                >
                    <div className="modal-content">
                        <div className="modal-header bg-fleet">
                            <h4 className="modal-title text-white" id="myModalLabel3">
                                <i className="ft-download align-middle icon-modal-title"></i>
                                <FormattedMessage id="disponibilidadGrid.render.export_modal.header_exportar_disponibilidad" defaultMessage=" Exportar Disponibilidad" />
                            </h4>
                            <button type="button" onClick={props.handleClose} className="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div className="modal-body modal-grey modal-mh ovf-x-hidden">
                            <div className="row">
                                <div className="col-md-12">
                                    <form className="form form-horizontal">
                                        <div className="form-body">
                                            <div className="card pull-up">
                                                <div className="card-content">
                                                    <div className="card-body">
                                                        <h4 className="form-section">
                                                            <i className="la la-columns"></i>
                                                            <FormattedMessage id="disponibilidadGrid.render.export_modal.columns_to_export.header_columnas_a_exportar" defaultMessage=" Columnas a exportar" />
                                                        </h4>
                                                        <Grid container item xs={12} spacing={3} style={{ marginBottom: 20 }}>
                                                            <Grid component={Box} item xs={ITEM_XS} className="align-self-end">
                                                                <label className="col-md-6 label-control col-form-label" htmlFor="dominio">
                                                                    <FormattedMessage id="disponibilidadGrid.render.export_modal.columns_export.label_dominio" defaultMessage="Dominio:" />
                                                                </label>
                                                                <Switch
                                                                    onChange={(event) => handleDataExport("dominio")}
                                                                    checked={dataToExport.dominio}
                                                                    value={dataToExport.dominio}
                                                                    id="dominio"
                                                                    name="dominio"
                                                                    offColor="#FF4961"
                                                                    onColor="#28D094"
                                                                    disabled={false}
                                                                    className="col-md-6 align-middle"
                                                                />
                                                            </Grid>

                                                            <Grid component={Box} item xs={ITEM_XS} className="align-self-end">
                                                                <label className="col-md-6 label-control col-form-label" htmlFor="motivo">
                                                                    <FormattedMessage id="disponibilidadGrid.render.export_modal.columns_export.label_motivo" defaultMessage="Motivo:" />
                                                                </label>
                                                                <Switch
                                                                    onChange={(event) => handleDataExport("motivo")}
                                                                    checked={dataToExport.motivo}
                                                                    value={dataToExport.motivo}
                                                                    id="motivo"
                                                                    name="motivo"
                                                                    offColor="#FF4961"
                                                                    onColor="#28D094"
                                                                    disabled={false}
                                                                    className="col-md-6 align-middle"
                                                                />
                                                            </Grid>

                                                            <Grid component={Box} item xs={ITEM_XS} className="align-self-end">
                                                                <label className="col-md-6 label-control col-form-label" htmlFor="fechaRetorno">
                                                                    <FormattedMessage id="disponibilidadGrid.render.export_modal.columns_export.label_fechaRetorno" defaultMessage="Fecha Retorno:" />
                                                                </label>
                                                                <Switch
                                                                    onChange={(event) => handleDataExport("fechaRetorno")}
                                                                    checked={dataToExport.fechaRetorno}
                                                                    value={dataToExport.fechaRetorno}
                                                                    id="fechaRetorno"
                                                                    name="fechaRetorno"
                                                                    offColor="#FF4961"
                                                                    onColor="#28D094"
                                                                    disabled={false}
                                                                    className="col-md-6 align-middle"
                                                                />
                                                            </Grid>

                                                            <Grid component={Box} item xs={ITEM_XS} className="align-self-end">
                                                                <label className="col-md-6 label-control col-form-label" htmlFor="modelo">
                                                                    <FormattedMessage id="disponibilidadGrid.render.export_modal.columns_export.label_modelo" defaultMessage="Modelo:" />
                                                                </label>
                                                                <Switch
                                                                    onChange={(event) => handleDataExport("modelo")}
                                                                    checked={dataToExport.modelo}
                                                                    value={dataToExport.modelo}
                                                                    id="modelo"
                                                                    name="modelo"
                                                                    offColor="#FF4961"
                                                                    onColor="#28D094"
                                                                    disabled={false}
                                                                    className="col-md-6 align-middle"
                                                                />
                                                            </Grid>

                                                            <Grid component={Box} item xs={ITEM_XS} className="align-self-end">
                                                                <label className="col-md-6 label-control col-form-label" htmlFor="tipoModelo">
                                                                    <FormattedMessage id="disponibilidadGrid.render.export_modal.columns_export.label_tipo" defaultMessage="Tipo:" />
                                                                </label>
                                                                <Switch
                                                                    onChange={(event) => handleDataExport("tipoModelo")}
                                                                    checked={dataToExport.tipoModelo}
                                                                    value={dataToExport.tipoModelo}
                                                                    id="tipoModelo"
                                                                    name="tipoModelo"
                                                                    offColor="#FF4961"
                                                                    onColor="#28D094"
                                                                    disabled={false}
                                                                    className="col-md-6 align-middle"
                                                                />
                                                            </Grid>

                                                            <Grid component={Box} item xs={ITEM_XS} className="align-self-end">
                                                                <label className="col-md-6 label-control col-form-label" htmlFor="base">
                                                                    <FormattedMessage id="disponibilidadGrid.render.export_modal.columns_export.label_base" defaultMessage="Base:" />
                                                                </label>
                                                                <Switch
                                                                    onChange={(event) => handleDataExport("base")}
                                                                    checked={dataToExport.base}
                                                                    value={dataToExport.base}
                                                                    id="base"
                                                                    name="base"
                                                                    offColor="#FF4961"
                                                                    onColor="#28D094"
                                                                    disabled={false}
                                                                    className="col-md-6 align-middle"
                                                                />
                                                            </Grid>

                                                            <Grid component={Box} item xs={ITEM_XS} className="align-self-end">
                                                                <label className="col-md-6 label-control col-form-label" htmlFor="subregion">
                                                                    <FormattedMessage id="disponibilidadGrid.render.export_modal.columns_export.label_sub_region" defaultMessage="Sub Región:" />
                                                                </label>
                                                                <Switch
                                                                    onChange={(event) => handleDataExport("subregion")}
                                                                    checked={dataToExport.subregion}
                                                                    value={dataToExport.subregion}
                                                                    id="subregion"
                                                                    name="subregion"
                                                                    offColor="#FF4961"
                                                                    onColor="#28D094"
                                                                    disabled={false}
                                                                    className="col-md-6 align-middle"
                                                                />
                                                            </Grid>

                                                            <Grid component={Box} item xs={ITEM_XS} className="align-self-end">
                                                                <label className="col-md-6 label-control col-form-label" htmlFor="region">
                                                                    <FormattedMessage id="disponibilidadGrid.render.export_modal.columns_export.label_region" defaultMessage="Región:" />
                                                                </label>
                                                                <Switch
                                                                    onChange={(event) => handleDataExport("region")}
                                                                    checked={dataToExport.region}
                                                                    value={dataToExport.region}
                                                                    id="region"
                                                                    name="region"
                                                                    offColor="#FF4961"
                                                                    onColor="#28D094"
                                                                    disabled={false}
                                                                    className="col-md-6 align-middle"
                                                                />
                                                            </Grid>
                                                            
                                                            {ConfigBusiness.get('moviles.transportadora.grilla') === 'true' ? (
                                                                <Grid component={Box} item xs={ITEM_XS} className="align-self-end">
                                                                    <label className="col-md-6 label-control col-form-label" htmlFor="transportadora">
                                                                        <FormattedMessage id="disponibilidadGrid.render.export_modal.columns_export.label_transportadora" defaultMessage="Transportadora:" />
                                                                    </label>
                                                                    <Switch
                                                                        onChange={(event) => handleDataExport("transportadora")}
                                                                        checked={dataToExport.transportadora}
                                                                        value={dataToExport.transportadora}
                                                                        id="transportadora"
                                                                        name="transportadora"
                                                                        offColor="#FF4961"
                                                                        onColor="#28D094"
                                                                        disabled={false}
                                                                        className="col-md-6 align-middle"
                                                                    />
                                                                </Grid>
                                                            ) : ''}

                                                            <Grid component={Box} item xs={ITEM_XS} className="align-self-end">
                                                                <label className="col-md-6 label-control col-form-label" htmlFor="cecos">
                                                                    <FormattedMessage id="disponibilidadGrid.render.export_modal.columns_export.label_centro_de_costos" defaultMessage="Centro de Costos:" />
                                                                </label>
                                                                <Switch
                                                                    onChange={(event) => handleDataExport("cecos")}
                                                                    checked={dataToExport.cecos}
                                                                    value={dataToExport.cecos}
                                                                    id="cecos"
                                                                    name="cecos"
                                                                    offColor="#FF4961"
                                                                    onColor="#28D094"
                                                                    disabled={false}
                                                                    className="col-md-6 align-middle"
                                                                />
                                                            </Grid>

                                                            <Grid component={Box} item xs={ITEM_XS} className="align-self-end">
                                                                <label className="col-md-6 label-control col-form-label" htmlFor="fechaHoraInicioOciosidad">
                                                                    <FormattedMessage id="disponibilidadGrid.render.export_modal.columns_export.label_fechaHoraInicioOciosidad" defaultMessage="Fecha y hora inicio ociosidad:" />
                                                                </label>
                                                                <Switch
                                                                    onChange={(event) => handleDataExport("fechaHoraInicioOciosidad")}
                                                                    checked={dataToExport.fechaHoraInicioOciosidad}
                                                                    value={dataToExport.fechaHoraInicioOciosidad}
                                                                    id="fechaHoraInicioOciosidad"
                                                                    name="fechaHoraInicioOciosidad"
                                                                    offColor="#FF4961"
                                                                    onColor="#28D094"
                                                                    disabled={false}
                                                                    className="col-md-6 align-middle"
                                                                />
                                                            </Grid>

                                                            <Grid component={Box} item xs={ITEM_XS} className="align-self-end">
                                                                <label className="col-md-6 label-control col-form-label" htmlFor="horasOciosidad">
                                                                    <FormattedMessage id="disponibilidadGrid.render.export_modal.columns_export.label_horasOciosidad" defaultMessage="Horas ociosidad:" />
                                                                </label>
                                                                <Switch
                                                                    onChange={(event) => handleDataExport("horasOciosidad")}
                                                                    checked={dataToExport.horasOciosidad}
                                                                    value={dataToExport.horasOciosidad}
                                                                    id="horasOciosidad"
                                                                    name="horasOciosidad"
                                                                    offColor="#FF4961"
                                                                    onColor="#28D094"
                                                                    disabled={false}
                                                                    className="col-md-6 align-middle"
                                                                />
                                                            </Grid>

                                                            <Grid hidden={!props.reservaHabilitado} component={Box} item xs={ITEM_XS} className="align-self-end">
                                                                <label className="col-md-6 label-control col-form-label" htmlFor="esReserva">
                                                                    <FormattedMessage id="disponibilidadGrid.render.export_modal.columns_export.label_esReserva" defaultMessage="Es Reserva" />
                                                                </label>
                                                                <Switch
                                                                    onChange={(event) => handleDataExport("esReserva")}
                                                                    checked={dataToExport.esReserva}
                                                                    value={dataToExport.esReserva}
                                                                    id="esReserva"
                                                                    name="esReserva"
                                                                    offColor="#FF4961"
                                                                    onColor="#28D094"
                                                                    disabled={false}
                                                                    className="col-md-6 align-middle"
                                                                />
                                                            </Grid>
                                                        </Grid>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-md-12 alert alert-info small" role="alert">
                                                <FormattedMessage id="disponibilidadGrid.render.export_modal.columns_export.information_esta_accion_puede_demorar_unos_minutos" defaultMessage="Esta acción puede demorar unos minutos." />
                                            </div>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                        <div className="modal-footer modal-grey">
                            <button type="button" className="btn btn-default btn-fleet" onClick={handleExportExcel}>
                                <i className={loading ? 'la la-spinner spinner' : 'fa fa-download'}></i>
                                <FormattedMessage id="disponibilidadGrid.render.export_modal.finish_button.exportar_a_excel" defaultMessage=" Exportar a Excel" />
                            </button>
                            <button type="button" className="btn btn-danger" onClick={props.handleClose}>
                                <i className="fa fa-times-circle"></i>
                                <FormattedMessage id="disponibilidadGrid.render.export_modal.finish_button.cancelar" defaultMessage=" Cancelar" />
                            </button>
                        </div>
                    </div>
                </div>
            </Grow>
        </Modal>
    );
};

export default DisponibilidadGridExport;